import React from 'react';
import { Image } from 'react-konva';
// import { cloneDeep } from 'lodash';
import {
  sideFrameLength,
  dualPedigreeLaunchOnDev,
  defaultZoomLevelValueForDualPedigree,
  // isSeinfeld,
  defaultPercentOfZoomLevelForDualPedigree,
  spanOutDualPedigreeProfilessBy,
  // dimDualPedigreeSVGFrames,
} from '../../../library/constants';
import { getSVGInnerPattern, getImgURLdataFromSVG } from '../../../library/calc';
import {
  selectSVGFrame,
  urlGet,
  widenGreatGrandParentsForDualPedigree,
  shiftForUnionRoot,
  doWhenReady,
  isMobileTablet
} from '../../../library/calc.js';

let  testNode  = urlGet('testNode');
const enlargeRatioForMediumToLargeGeniImages = 3.2

export class FrameBorder extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      imageFrame: null,
      frame: null,
    }

    this.frameStyle = this.props.dualPedigreeObj.frameStyle;

  }

  callClick(){
    this.props.showDualPedigreeModal({node: this.props.nodeObj.n, content: 'crop'});
  }
  countFoo = 0;
  componentDidMount(){

      // this.countFoo++;
      // clearTimeout(this.throttle);
      // this.throttle = setTimeout(() => {
      //    console.log(`%c Count: ${this.countFoo}`, [
      //    'color: white',
      //    'background:  green',
      //    'font-size: 14px',
      //    'border: 5px solid red',
      //    'padding: 10px',
      //    ].join(';'));

      //    this.countFoo = 0;
      // }, 800);

    // if( this.props.nodeObj.prId  !== parseInt(testNode, 10) )   return  null
    //
    // this.imageElementRef = React.createRef();

    this.loadFrameWithSVGBlob();

    // if( this.props.nodeObj.n === 34 && dualPedigreeLaunchOnDev ) this.callClick()

  }

  refLoadFrameWithSVGBlob(){
    const doForceUpdateCanvas = true;
    this.loadFrameWithSVGBlob(doForceUpdateCanvas);
  }

  resetHiResImgLoaded(){
    this.hiResImgLoaded = false;
  }

  hiResImgLoaded = false;
  componentDidUpdate(){

    // if( typeof(this.props.nodeObj.prId) !== 'undefined' ) console.log('cdu:', this.props.nodeObj.nm);

    if(!this.props.highResolutionImagesForDualPedigree &&
      this.props.dualPedigreeObj.frameStyle !== this.frameStyle){

      this.frameStyle = this.props.dualPedigreeObj.frameStyle;

      this.loadFrameWithSVGBlob();

    }

    if(
      this.props.nodeObj.img.type !== 'placeholder' &&
      this.props.highResolutionImagesForDualPedigree &&
      !this.hiResImgLoaded){

      this.loadFrameWithSVGBlob();

      // console.log('loadFrameWithSVGBlob: ', this.props.nodeObj.prId);
    }
  }

  dualPedigreedHashImgMedLargeSizes={}
  loadFrameWithSVGBlob(doForceUpdateCanvas){


    let imgType = undefined;
    let profileUrl = undefined;
    let tmedUrl = undefined;
    let tlrgUrl = undefined;
    let lowResSizeUploadedAs = undefined;
    // let isImgLandscape = false;

    if(this.props.nodeObj.img.type === 'placeholder' || typeof(this.props.nodeObj.nvp) !== 'undefined' ) {
      imgType = 'placeholder';
      profileUrl = this.props.nodeObj.img.src;
      const ghostImgLocation = '/canvas-tree/imgs/dualpedigree/ghosts/';
      if( this.props.nodeObj.side === 'right' ){
          profileUrl = ghostImgLocation + ( this.props.nodeObj.g  === 'm' ? 'fatherSiloR.svg': 'motherSiloR.svg');
      } else {
          profileUrl = ghostImgLocation + ( this.props.nodeObj.g  === 'm' ? 'fatherSiloL.svg': 'motherSiloL.svg');
      }

      if( typeof(this.props.nodeObj.nvp) !== 'undefined' ||  this.props.nodeObj.g  === 'u') {

        if( this.props.nodeObj.side === 'right' ){
          profileUrl = ghostImgLocation + 'ungenderedHumanR.svg';
        } else {
          profileUrl = ghostImgLocation + 'ungenderedHumanL.svg';
        }
      }

    } else {
      imgType = 'profile';
      profileUrl = this.props.nodeObj.img.src;
      tmedUrl = this.props.nodeObj.tmed;
      tlrgUrl = this.props.nodeObj.tlrg;

      if( this.props.highResolutionImagesForDualPedigree ){

        /*

          High resolution for UX.

         */

        if( this.props.nodeObj.n  === parseInt(testNode, 10) ) console.log(`highResolutionImagesForDualPedigree: `, this.props.highResolutionImagesForDualPedigree);

        profileUrl = ( typeof(tlrgUrl) !== 'undefined' ? tlrgUrl: tmedUrl);

      }  else {

        /*

          Low resolution for UX.

         */

        if( this.props.nodeObj.n  === parseInt(testNode, 10) ) console.log(`highResolutionImagesForDualPedigree: `, this.props.highResolutionImagesForDualPedigree);

        if( /large/i.test(profileUrl) ){
          if( this.props.nodeObj.n  === parseInt(testNode, 10) ) console.log('Switch large to medium');
          // profileUrl = profileUrl.replace("_large.", "_medium.");
          profileUrl = tmedUrl;
          lowResSizeUploadedAs =  'medium';
        }

        if( /original/i.test(profileUrl) ){
          if( this.props.nodeObj.n  === parseInt(testNode, 10) ) console.log ('Switch original to medium');
          // profileUrl = profileUrl.replace("_original.", "_medium.");
          profileUrl = tmedUrl
          lowResSizeUploadedAs =  'original';
        }

      }

    }

    /*
      const imageBasePath = '/canvas-tree/imgs/';
      // profileUrl = imageBasePath + 'sample_medium_2.jpeg';
      // profileUrl = imageBasePath + 'fauci.png';
      // profileUrl = imageBasePath + 'biden.jpg';
      profileUrl = imageBasePath + 'sample_medium_1.jpeg';
      imgType = 'profile';
     */

    if(
      this.props.nodeObj.img.type !== 'placeholder' &&
      this.props.highResolutionImagesForDualPedigree &&
      !this.hiResImgLoaded){
      // console.log(`this.props.nodeObj.img.src: `, this.props.nodeObj.img.src);
      // console.log(`profileUrl: `, profileUrl);
    }

    const imageFrame = new window.Image();
    const imageProfile = new window.Image();

    imageProfile.src = profileUrl;
    imageProfile.crossOrigin = "Anonymous";

    imageProfile.onload = () => {

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        let dataURL;
        // let naturalWidth;
        // let naturalHeight;

        const nodeObj = this.props.nodeObj;
        const node = this.props.nodeObj.n
        let custom = nodeObj.dualPedigreeCustom;

        // if( typeof(custom) === 'undefined'){
        //   custom = {
        //     zoomLevelValue: defaultZoomLevelValueForDualPedigree,
        //   }
        //   this.props.postPoster({
        //     action: 'saveDefaultCentering',
        //     node: this.props.nodeObj.n,
        //     custom,
        //   });
        // }

        const naturalWidth = imageProfile.naturalWidth;
        const naturalHeight = imageProfile.naturalHeight;

        canvas.width = naturalWidth;
        canvas.height = naturalHeight;

        let shiftX = undefined;
        let shiftY = undefined;
        let newScaledWidth = undefined;
        let newScaledHeight = undefined;

        if(this.props.nodeObj.img.type === 'real') {

          if( typeof(custom) !== 'undefined' && typeof(custom.shiftX) !== 'undefined' ){
            shiftX = custom.shiftX;
          } else{

            shiftX = -1 * (( !this.props.highResolutionImagesForDualPedigree ? naturalWidth: this.dualPedigreedHashImgMedLargeSizes[node].mediumNaturalWidth) / 2);
          }
          if( typeof(custom) !== 'undefined' && typeof(custom.shiftY) !== 'undefined' ){
            shiftY = custom.shiftY;
          } else{
            shiftY = -1 * (( !this.props.highResolutionImagesForDualPedigree ? naturalHeight: this.dualPedigreedHashImgMedLargeSizes[node].mediumNaturalHeight) / 2);
          }

          const zoomLevel = ( typeof(custom) !== 'undefined' && typeof(custom.zoomLevelValue) !== 'undefined' ? custom.zoomLevelValue:  defaultZoomLevelValueForDualPedigree);

          newScaledWidth = naturalWidth + ( naturalWidth * (zoomLevel*  defaultPercentOfZoomLevelForDualPedigree));
          newScaledHeight = naturalHeight + ( naturalHeight * (zoomLevel*  defaultPercentOfZoomLevelForDualPedigree));

          if(!this.props.highResolutionImagesForDualPedigree){

            // custom.printWidth = newScaledWidth;
            // custom.printHeight = newScaledHeight;
            // custom.lowResWidth = naturalWidth;
            // custom.lowResHeight = naturalHeight;
            // custom.width = newScaledWidth;
            // custom.height = newScaledHeight;
            custom.mediumWidth = naturalWidth;
            custom.mediumHeight = naturalHeight;
            custom.mediumUrl = imageProfile.src;

          }  else{

            custom.largeWidth = naturalWidth;
            custom.largeHeight = naturalHeight;
            custom.largeUrl = imageProfile.src;

            // custom.hiResWidth = naturalWidth;
            // custom.hiResHeight = naturalHeight;
          }

          if( this.props.nodeObj.n === parseInt(testNode, 10) ){

            // console.log(`name: `, this.props.nodeObj.nm);
            // console.log(`custom: `, JSON.stringify(custom, null, 2));
            // console.log(`defaultPercentOfZoomLevelForDualPedigree: `, defaultPercentOfZoomLevelForDualPedigree);
            // console.log(`custom.zoomLevelValue: `, custom.zoomLevelValue);
            // console.log(`naturalWidth: `, naturalWidth);
            // console.log(`newScaledWidth: `, naturalWidth + ( naturalWidth * (custom.zoomLevelValue * defaultPercentOfZoomLevelForDualPedigree)));

            console.log(JSON.stringify({
              using: imageProfile.src,
              name: this.props.nodeObj.nm,
              node: this.props.nodeObj.n,
              lowResSizeUploadedAs,
              naturalWidth,
              naturalHeight,
              newScaledWidth,
              newScaledHeight,
              ...custom,
            }, null, 2));


          }

        } else {

          // Placeholder

          shiftX = 0;
          shiftY = 0;

          canvas.width = 500;
          canvas.height = 500;

        }

        ctx.drawImage(imageProfile, 0, 0);
        dataURL = canvas.toDataURL("image/png");
        // let userCustomFormatedImg = false;
        let frameObj = {
                          frame: this.props.dualPedigreeObj.frameStyle,
                          imgType,
                          dataURL,
                          shiftX,
                          shiftY,
                          testColor: this.props.nodeObj.testColor,
                        };

          let mediumAndLargeImageHaveSameDimensions = false;

          if( typeof(this.props.nodeObj.prId) !== 'undefined' && imgType === 'profile'){

            if( !this.props.highResolutionImagesForDualPedigree ){

              this.dualPedigreedHashImgMedLargeSizes[node] = {};
              this.dualPedigreedHashImgMedLargeSizes[node].low = profileUrl;
              this.dualPedigreedHashImgMedLargeSizes[node].mediumNaturalWidth = naturalWidth;
              this.dualPedigreedHashImgMedLargeSizes[node].mediumNaturalHeight = naturalHeight;

            }

            if( this.props.highResolutionImagesForDualPedigree ){

              this.dualPedigreedHashImgMedLargeSizes[node].high = profileUrl;
              this.dualPedigreedHashImgMedLargeSizes[node].largeNaturalWidth = naturalWidth;
              this.dualPedigreedHashImgMedLargeSizes[node].largeNaturalHeight = naturalHeight;

              if( this.dualPedigreedHashImgMedLargeSizes[node].mediumNaturalWidth === this.dualPedigreedHashImgMedLargeSizes[node].largeNaturalWidth &&
                  this.dualPedigreedHashImgMedLargeSizes[node].mediumNaturalHeight === this.dualPedigreedHashImgMedLargeSizes[node].largeNaturalHeight
              ){
                mediumAndLargeImageHaveSameDimensions = true;
              }

            }
          }




        if( this.props.nodeObj.img.type === 'placeholder' || typeof(this.props.nodeObj.nvp) !== 'undefined'){
            // Do nothing here
        } else if( typeof(this.props.nodeObj.dualPedigreeCustom.width) !== 'undefined' ){

          // userCustomFormatedImg = true;
          frameObj = {...frameObj,
              width: this.props.nodeObj.dualPedigreeCustom.width,
              height: this.props.nodeObj.dualPedigreeCustom.height,
          }

        } else {

          if(this.props.highResolutionImagesForDualPedigree && !mediumAndLargeImageHaveSameDimensions){
            frameObj = {...frameObj,
                width: newScaledWidth/enlargeRatioForMediumToLargeGeniImages,
                height: newScaledHeight/enlargeRatioForMediumToLargeGeniImages,
            }
          } else {
            frameObj = {...frameObj,
                width: newScaledWidth,
                height: newScaledHeight,
            }
          }

        }

        if( this.props.nodeObj.n === parseInt(testNode, 10) ){

          // console.log(`:> `, JSON.stringify({
          //   userCustomFormatedImg,
          //   width: frameObj.width,
          //   height: frameObj.height,
          //   shiftX: frameObj.shiftX,
          //   shiftY: frameObj.shiftY,
          // }, null, 2));

        }

        if(this.props.nodeObj.img.type === 'real' &&
          typeof(nodeObj.dualPedigreeCustom.width) === 'undefined' &&
          typeof(nodeObj.dualPedigreeCustom.height) === 'undefined' &&
          typeof(nodeObj.dualPedigreeCustom.shiftX) === 'undefined' &&
          typeof(nodeObj.dualPedigreeCustom.shiftY) === 'undefined'
        ) {

          this.props.postPoster({
            action: 'saveDefaultCentering',
            node: this.props.nodeObj.n,
            custom: {
              zoomLevelValue: defaultZoomLevelValueForDualPedigree,
              width: frameObj.width,
              height: frameObj.height,
              shiftX: frameObj.shiftX,
              shiftY: frameObj.shiftY,
            },
          });

        }


        dataURL = this.getFrame(frameObj);

        let url = getImgURLdataFromSVG(dataURL);

        imageFrame.src = url;
        // imageFrame.width = naturalWidth;
        // imageFrame.height = naturalHeight;
        imageFrame.crossOrigin = "Anonymous";
        imageFrame.onload = () => {

          this.setState({
            imageFrame: imageFrame
          });

          if( typeof(this.props.nodeObj.prId) !== 'undefined' && imgType === 'profile'){
            if( !this.props.highResolutionImagesForDualPedigree ){
              this.props.countDualPedigreeImgLoaded({node:  this.props.nodeObj.n, forPreview: true});
            }
            if( this.props.highResolutionImagesForDualPedigree ){
              this.props.countDualPedigreeImgLoaded({node:  this.props.nodeObj.n, forRender: true});
              this.hiResImgLoaded = true;
            }
          }

          if( typeof(doForceUpdateCanvas) !== 'undefined' ) this.props.forceUpdateCanvas('loadFrameWithSVGBlob');

        }
    }

  }

  notifyOfErrorMaxPoster(){

    let description = 'You must remove a poster in order to proceed.';
    let message = 'Error';
    if( typeof(window.trl) !== 'undefined' ) description = window.trl(description, 'Error message notification max poster')
    if( typeof(window.trl) !== 'undefined' ) message = window.trl(message, 'Error message notification max poster')
    const type = 'error';
    const position = 'bc';
    const duration = 3;
    const onOpen = () => {
      // console.log('MOO');
    }
    const onClose = () => {
      // console.log('BOO');
    }

    this.props.notifyWithAtom({which:'InviteMsg', description, message, type, position, duration, onOpen, onClose});

  }

  getFrame = ({frame, imgType, dataURL, width, height, shiftX, shiftY, testColor}) => {

    const imgProfileSVGPattern = getSVGInnerPattern({frame, imgType, dataURL, width, height, shiftX, shiftY, node: this.props.nodeObj.n, fromWhere: 'treeView'});
    return selectSVGFrame({imgProfileSVGPattern, dataURL, frame, testColor});

  }

  mouseEnter(){

    this.props.cursorBecomesPointer()
  }

  mouseLeave(){

    this.props.cursorBecomesMove();

  }

  launchSomeModal({node, prId}){
    if(typeof(this.props.nodeObj.nvp) !== 'undefined') return;
    if(this.props.nodeObj.img.type === 'placeholder' && !dualPedigreeLaunchOnDev){

    if((typeof(this.props.dualPedigreeObj) !== 'undefined' && this.props.dualPedigreeObj.posterMaxLimitReached ) ||
      dualPedigreeLaunchOnDev
    ){

      this.notifyOfErrorMaxPoster();

    } else {

      window.addPhoto(
        prId, // highlight_pr_id -- this pr_id that we are uploading picture
        prId // focus_pr_id -- bring tree back to focus node tree
      );

      if(isMobileTablet()){

        const whenAddPhotoModalAppears = () => {


          return document.querySelector('#thin-border-lightbox .lightbox_thin') != null;
        }

        const doThisCallback = () => {

          const addPhotoModal = document.querySelectorAll('#thin-border-lightbox');
          addPhotoModal.forEach((element)=>{
            element.style.setProperty('top', '8%', "important");
          });
        }

        doWhenReady({argument: '', condition: whenAddPhotoModalAppears, callback: doThisCallback, attempts: {ongoing:0, end: 99999999}, fromWhere: 'launchSomeModal'});

      } else {

        const whenAddPhotoModalAppears = () => {
          return document.querySelector('#thin-border-lightbox .lightbox_thin') != null;
        }

        const doThisCallback = () => {

          const thinBorderLightboxHeight = 480;
          const thinBorderLightbox = document.getElementById("thin-border-lightbox")
          const topMargin =  (this.props.canvasHeight - thinBorderLightboxHeight) / 2;
          const topString = `${topMargin}px`;
          thinBorderLightbox.style.setProperty("top", topString, "important");

        }

        doWhenReady({argument: '', condition: whenAddPhotoModalAppears, callback: doThisCallback, attempts: {ongoing:0, end: 99999999}, fromWhere: 'launchSomeModal'});

      }


    }

    } else {

    if((typeof(this.props.dualPedigreeObj) !== 'undefined' && this.props.dualPedigreeObj.posterMaxLimitReached ) /*||
    dualPedigreeLaunchOnDev*/
    ){

    this.notifyOfErrorMaxPoster();

    } else {

    this.props.showDualPedigreeModal({node, content: 'crop'});

    }

    }
  }

  render() {

    let {
      idp,
      left,
      top,
      isGGP,
      side,
      isChildrenOfDualPedFocusUnion,
      origTop,
    } = this.props;

    const node = this.props.nodeObj.n;
    const prId = this.props.nodeObj.prId;

    top -= 10;
    if( this.props.dualPedigreeObj.whichChildrenNode ===  -1 && typeof(origTop) !== 'undefined' ) top = origTop;

    let adaptedSideFrameLength = sideFrameLength;

    if( isGGP || typeof(isChildrenOfDualPedFocusUnion) !== 'undefined'){

      if( side === 'right') left += 17
      if( side === 'left') left -= 2
      if( side === 'middle') left += 15

      adaptedSideFrameLength -= 15;
      top = top + adaptedSideFrameLength/4;
      top = widenGreatGrandParentsForDualPedigree({top, idp});

    }

    if( idp ===  1 ){ // FOCUS LEFT AND RIGHT PROFILES

      left = shiftForUnionRoot({side, left})

    } else {

      if( side === 'left'){

        left -= spanOutDualPedigreeProfilessBy;

      }

      if( side === 'right'){

        left += spanOutDualPedigreeProfilessBy;

      }

    }

    if(this.props.shouldHideChildrenForDualPedigree({nodeObj: this.props.nodeObj})) return null;
    if(this.props.nodeObj.oneOfTooMany  && !this.props.isSingleChildForDualPedigree({nodeObj: this.props.nodeObj})){
      return null;
    }

    if(this.props.isSingleChildForDualPedigree({nodeObj: this.props.nodeObj})) {
      top = this.props.nodeObj.singleChildTop;
    }

    if(this.props.isSingleChildForDualPedigree({nodeObj: this.props.nodeObj}) &&  this.props.nodeObj.oneOfTooMany) {
      top = this.props.nodeObj.singleChildTop;
      left += 20;
    }

    return (
             <Image
                cursor={'pointer'}
                image={this.state.imageFrame}
                scaleX={.01}
                scaleY={.01}
                width={adaptedSideFrameLength * 100}
                height={adaptedSideFrameLength * 100}
                x={left}
                y={top}
                onMouseEnter={this.mouseEnter.bind(this)}
                onMouseLeave={this.mouseLeave.bind(this)}
                onTouchStart={()=>{
                  this.launchSomeModal({node, prId})
                }}
                onClick={
                  ()=>{
                    this.launchSomeModal({node, prId});
                  }
                }
             >
             </Image>
    );

  }
}

